import { useTranslation } from "react-i18next"
import { Link, useParams } from 'react-router-dom'

export const EmailSend = () => {
    const { t } = useTranslation()
    const { email } = useParams()

    return (
        <div className="auth-page">
            <div className="auth-card text-center">
                <div className="mb-4">
                    <img src="/images/logo-inicio.png" alt="logotipo" height={40} />
                </div>
                <div className="mb-4" style={{ fontSize: '48px', color: 'var(--success)' }}>
                    <i className="fas fa-envelope"></i>
                </div>
                <h4 className="mb-3">{t('forgot.emailsend1')}</h4>
                <p className="h4 fw-bold mb-3" style={{ color: 'var(--primary)' }}>{email}</p>
                <p className="text-muted mb-4">{t('forgot.emailsend2')}</p>
                <div className="mb-4">
                    <Link to="/forgotpassword" className="link-underline">{t('forgot.emailsend3')}</Link>
                </div>
                <Link className="btn btn-secondary" to="/login">
                    <i className='fas fa-chevron-left'></i> {t('global.return')}
                </Link>
            </div>
        </div>
    )    
}
